export default __webpack_public_path__ + "static/RootSans-1Thin-40466b26f799cd06b7916c73a5d6b7ba.woff2";